import p2pConnectionStore from './P2PConnectionStore';
import liveSessionService from './LiveSessionService';
import liveSessionLogger from './LiveSessionLogger';

const PROCTOR_STREAM_SOURCE_GAIN_NODE_MAP = new Map();

const proctorAudioService = {
    addOrRemoveProctorStreamToFromP2PConnection(messagerId, proctoringMode, studentApp) {
        const recordManager = studentApp.getRecorder();
        const liveAudioContext = recordManager.getLiveAudioContext();
        const audioRecord = recordManager.getAudioRecord();

        if (liveSessionService.isCallProctoringMode({ proctoringMode })) {
            const remoteStreamingFromProctor = p2pConnectionStore.getLatestRemoteAudioStreamByMessagerId(messagerId);
            if (remoteStreamingFromProctor) {
                const proctorStreamSource = liveAudioContext.createMediaStreamSource(remoteStreamingFromProctor);

                const gainNode = liveAudioContext.createGain();
                gainNode.gain.value = 1;
                proctorStreamSource.connect(gainNode);

                PROCTOR_STREAM_SOURCE_GAIN_NODE_MAP.set(messagerId, gainNode);

                liveSessionLogger.addEvent(messagerId, 'Adding proctor stream source.');
                audioRecord.connectAudioStreamSourceToRecordWorklet(gainNode);
            }
        } else if (liveSessionService.isWatchProctoringMode({ proctoringMode })) {
            if (PROCTOR_STREAM_SOURCE_GAIN_NODE_MAP.has(messagerId)) {
                const proctorGainNode = PROCTOR_STREAM_SOURCE_GAIN_NODE_MAP.get(messagerId);
                liveSessionLogger.addEvent(messagerId, 'Stopping proctor stream source.');
                proctorGainNode.disconnect();
                PROCTOR_STREAM_SOURCE_GAIN_NODE_MAP.delete(messagerId);
            }
        }
    },
};

export default proctorAudioService;
